import { useUser } from "../../context/UserContext";
import { useEffect, useState } from "react";
import FormPeriode from "./FormPeriode";
import ListPeriode from "./ListPeriode";
import { fetchSchoolHolidays } from "../../utils/vacances";
const PeriodeScolaire = ({typeComponent, elevesnat}) => {

       const { user, isAuthenticated, init,fetchUserData,etablissementData, fetchEtablissementData } = useUser();
 
       const [periode, setPeriode] = useState([])

  
       useEffect(() => {
               async function getVacances() {
                 // Appelle la fonction fetchSchoolHolidays qui renvoie un objet avec { vacances, periode }
                 const {periode } = await fetchSchoolHolidays();
                 // Mets à jour ton état avec les vacances récupérées
              
                 setPeriode(periode)  
               
               }
               getVacances();
             }, []);

       if(user && user.role !=="chef"){
        return (
            <div> Vous n'êtes pas autorisé à entrer dans cette section.</div>
        )
       }
       else if(etablissementData && etablissementData.periodes_scolaires.length ===0){
        return(
            <FormPeriode periode={periode} />
        )
       }
       else{
        return(
            <ListPeriode />
        )
       }

}

export default PeriodeScolaire;
